import { http } from '@/lib/http';

/**
 * Mirrors `repo.BusinessType` in the vizitpro-api swagger spec — the static
 * lookup of business categories VizitPro supports.
 */
export interface BusinessTypeDto {
  id: string;
  slug: string;
  label: string;
  is_active: boolean;
  created_at: string;
}

/**
 * React Query cache key for the business-types lookup. Static reference
 * data — safe to cache for the lifetime of the app session.
 */
export const BUSINESS_TYPES_QUERY_KEY = ['business-types'] as const;

/** Calls `GET /business-types`. */
export async function listBusinessTypes(): Promise<BusinessTypeDto[]> {
  const { data } = await http.get<BusinessTypeDto[]>('/business-types');
  return data;
}
